import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenTextSplitOn',
})
export class ShortenTextSplitOnPipe implements PipeTransform {
  transform(value: string, splitOn: string, length = 30) {
    value = value.trim().replace(' ', '');
    let result = value.trim().replace(' ', '');
    let split = value.split(splitOn);
    if (split.length > 1) {
      if (value.length > length) {
        result =
          split[0].substring(0, length - split[split.length - 1].length) +
          '...' +
          split[split.length - 1];
      }
    }
    return result;
  }
}
